import computeScrollIntoView from 'compute-scroll-into-view';

/** Check if Element is a DOM Element */
const isDomElement = (element: Element) => {
  return (
    // eslint-disable-next-line no-eq-null
    element != null && typeof element === 'object' && element.nodeType === 1
  );
};

/** Scroll the item element into view if needed */
export const scrollNodeToView = (
  itemEl: Element | null,
  menuEl: Element | null,
  scrollPosition: 'nearest' | 'center'
) => {
  if (itemEl === null || !isDomElement(itemEl)) {
    return;
  }

  const actions = computeScrollIntoView(itemEl, {
    boundary: menuEl,
    block: scrollPosition,
    scrollMode: 'if-needed'
  });
  actions.forEach(({ el, top }) => {
    // eslint-disable-next-line no-param-reassign
    el.scrollTop = top;
  });
};

/**
 * given an array of anything and a check condition,
 * return indices of all children that match the condition
 *
 * @param array - array of anything
 * @param check - function, add this index or not
 *
 * @returns array of indices matching the check condition
 */
export const findAllMatched = <T>(
  array: T[],
  check: (child: T) => boolean | undefined
) => {
  const arrayOfSelectedIndices: number[] = [];
  if (Array.isArray(array)) {
    array.forEach((child, index) => {
      if (check(child)) {
        arrayOfSelectedIndices.push(index);
      }
    });
  }

  return arrayOfSelectedIndices;
};

/** given 2 arrays, return an array of non-matching elements */
export const findArraysDifference = (a: number[], b: number[]) => {
  let a1: number[];
  let b1: number[];
  if (a.length > b.length) {
    b1 = b;
    a1 = a;
  } else {
    b1 = a;
    a1 = b;
  }

  return a1.filter((x) => !b1.includes(x));
};
